import React from "react";
import Newsletter_45 from "../component/Newsletter_45";

function Newsletter_45_container() {
  return <Newsletter_45 />;
}

export default Newsletter_45_container;
